<template>
  <el-row type="flex" align="middle" class="bar">
    <div :style="{width: width1, background: color1, height}" class="bar__left">
      <gj-tooltip v-if="size === 'small'" :content="leftBarTip">
        <div class="bar__left--circle"
             :style="{background: color1, height: tipSize, width: tipSize}">
          <div class="bar__left--inner--circle"
               :style="{height: tipSize, width: tipSize}"
          ></div>
        </div>
      </gj-tooltip>
      <template v-else>
        <span class="bar__left--number">{{data[0].number}}</span>
      </template>
    </div>
    <div :style="{width: width2, background: color2, height}" class="bar__right">
      <span v-if="size !== 'small'" class="bar__right--number">{{data[0].number}}</span>
    </div>
  </el-row>
</template>

<script>

  const sizeMap = {
    small: {
      height: '5px'
    },
    default: {
      height: '20px'
    }
  };
  
  export default {
    name: "gj-compare-bar",
    props: {
      data: {
        type: Array, // [{number, color}, {number, color}]
        required: true
      },
      size: {
        type: String,
        default: 'default',
        validator: function (value) {
          return ['small', 'default'].indexOf(value) !== -1
        }
      },
      leftBarTip: {
        type: String,
        default: ''
      }
    },
    computed: {
      width1() {
        return `${this.data[0].number * 100 / (this.data[0].number + this.data[1].number)}%`;
      },
      width2() {
        return `${this.data[1].number * 100 / (this.data[0].number + this.data[1].number)}%`;
      },
      color1() {
        return this.data[0].color;
      },
      color2() {
        return this.data[1].color;
      },
      height() {
        return sizeMap[this.size].height;
      },
      tipSize() {
        return sizeMap[this.size].height;
      },
    }
  }
</script>

<style scoped>
  .bar {
    width: 100%;
    border-radius: 4px;
  }
  .bar__left {
    position: relative;
    right: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    padding-left: 8px;
  }
  .bar__left--circle,
  .bar__left--inner--circle {
    border-radius: 50%;
  }
  .bar__left--circle {
    position: absolute;
    right: -3px;
    margin-top: -3px;
    z-index: 99;
    padding: 3px;
  }
  .bar__left--inner--circle {
    background: #fff;
  }
  .bar__right {
    text-align: right;
    padding-right: 8px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .bar__left--number,
  .bar__right--number {
    color: #fff;
    font-size: 12px;
  }
</style>
